module.exports={
"header.industry.mall":`行业商城`,
"header.home":`主页`,
"header.solutions.apps":`行业CRM`,
"header.learning.center":`学习中心`,
"header.partner.portal":`伙伴门户`,
"header.pricing.plan":`产品定价`,
"header.my.orders":`我的订单`,
"header.login.cloudcc":`登录CloudCC`,
"header.logout":`退出登录`,
"header.login.industry.mall":`登录行业商城`,
"header.search":`搜索`,
"header.congrats.formal.partner":`恭喜您已成为正式伙伴`,
"header.logout.success":`退出成功`,
"footer.scan.follow":`扫码关注公众号`,
"footer.quick.links":`快速链接`,
"footer.why.cloudcc":`为什么CloudCC`,
"footer.business.platform":`业务中台`,
"footer.integration":`集成`,
"footer.paas.platform":`PaaS平台`,
"footer.case.center":`案例中心`,
"footer.data.security":`数据安全`,
"footer.gdpr.compliance":`GDPR合规`,
"footer.service.agreement":`服务协议`,
"footer.privacy.statement":`隐私声明`,
"footer.app.permissions":`应用权限`,
"footer.products.prices":`产品与价格`,
"footer.sales.cloud":`销售云`,
"footer.customer.service.cloud":`服务云`,
"footer.field.service.cloud":`现场服务云`,
"footer.marketing.cloud":`市场云`,
"footer.partner.cloud":`伙伴云`,
"footer.project.cloud":`项目云`,
"footer.social.cloud":`社交云`,
"footer.platform.cloud":`平台云`,
"footer.mobile.terminal":`移动端`,
"footer.versions.prices":`版本与价格`,
"footer.industry.solutions":`行业方案`,
"footer.manufacturing":`制造业`,
"footer.education.training":`教育培训`,
"footer.it.hightech":`IT高科技`,
"footer.city.operation":`城市运营`,
"footer.finance.industry":`金融行业`,
"footer.medical.devices":`医疗器械`,
"footer.tourism.industry":`旅游行业`,
"footer.legal.industry":`律师行业`,
"footer.service.support":`服务支持`,
"footer.partners":`合作伙伴`,
"footer.partner.support":`伙伴支持`,
"footer.help.center":`帮助中心`,
"footer.resource.center":`资源中心`,
"resource.solutions.customer.service.cloud":`服务云`,
"resource.solutions.field.service.cloud":`现场服务云`,
"resource.solutions.project.cloud":`项目云`,
"resource.solutions.partner.cloud":`伙伴云`,
"resource.solutions.business.cloud":`商务云`,
"resource.solutions.profit.cloud":`利润云`,
"resource.solutions.platform.cloud":`平台云`,
"navigation.banner.ai.empower":`AI 赋能 1天创建你的行业方案CRM`,
"navigation.banner.zero.tech.threshold":`零技术门槛`,
"navigation.banner.price.autonomy":`价格自主`,
"navigation.banner.permanent.profit.sharing":`永久分润`,
"navigation.banner.saas.entrepreneurship":`开启SaaS创业新时代`,
"navigation.banner.experience.now":`立即体验`,
"home.install.stats":`一共{0}个行业方案产品。近期安装{1}次。`,
"home.stats.total":`总计`,
"home.stats.industry.products":`个行业方案产品。累计安装`,
"home.stats.times":`次。`,
"footer.about.us":`关于我们`,
"footer.company.introduction":`公司介绍`,
"footer.company.news":`企业新闻`,
"footer.management.team":`管理团队`,
"footer.corporate.culture":`企业文化`,
"footer.development.history":`发展历程`,
"footer.qualifications.honors":`资质与荣誉`,
"footer.brand.culture":`品牌文化`,
"footer.join.cloudcc":`加入云动`,
"footer.contact.us":`联系我们`,
"footer.app.download":`APP下载`,
"footer.scan.qrcode":`扫描二维码下载手机APP`,
"footer.enter.mobile.store":`进入手机商城下载手机APP`,
"footer.telecom.license":`增值电信业务许可证: 京B2-20170892`,
"footer.copyright":`© 版权所有：北京神州云动科技股份有限公司`,
"footer.developer":`开发者：北京神州云动科技股份有限公司 版本所有`,
"footer.icp.registration":`京ICP备09016255号`,
"footer.icp.certificate":`京ICP证 110683号`,
"footer.public.security":`京公网安备110108008174号`,
"agreement.license":`许可协议`,
"agreement.i.agree":`我同意`,
"agreement.enterprise.agreement":`企业（或个人）入驻CloudCC商城协议`,
"agreement.i.agree.cloudcc":`我同意CloudCC的`,
"agreement.privacy.policy":`隐私政策`,
"agreement.and":`和`,
"agreement.terms.of.service":`服务条款`,
"agreement.apply.partner":`申请为伙伴`,
"agreement.must.agree.license":`您必须同意CloudCC许可协议`,
"agreement.must.agree.enterprise":`您必须同意企业或个人入驻CloudCC商城协议`,
"label.appstore.UntilMaturity.time":`距到期日期剩余时长`,
"label.appstore.list.payments":`一旦您订购了我们任意产品，您的付款方式将被列在这里.`,
"label.appstore.duedate":`应付日期`,
"label.appstore.Pay":`支付`,
"label.appstore.enterAddress":`请输入详细地址`,
"label.appstore.country":`国家`,
"label.appstore.Update.profile":`更新简档`,
"label.appstorePleaseEnter":`请输入`,
"label.appstore.useremail":`用户邮箱`,
"label.appstore.Enabled.quantity":`已启用数量`,
"label.appstore.Pay.gateway":`安全可靠的 支付网关`,
"label.appstore.year":`年`,
"label.appstore.Version.price":`版本及价格`,
"label.appstore.cancel":`取消`,
"label.appstore.selectMonth":`请选择月份`,
"label.appstore.Change.new.address":`您使用此账单地址的所有现有订购都将更改为新指定的地址`,
"label.appstore.noAccess":`可能原因：URL可能有误或者您可能无权访问`,
"label.appstore.MonthlyAmount":`每个月金额`,
"label.appstore.TechnicalDetails":`技术细节`,
"label.appstore.Please.enter.the.content":`请输入内容`,
"label.appstore.invoice":`发票`,
"home.explore.hot.categories":`探索热门类别`,
"home.use.appexchange":`使用 AppExchange 扩展 CloudCC`,
"home.appexchange.description":`AppExchange 是领先的企业云市场，拥有超过 9,000 个预构建和可定制应用程序，可用于扩展您的数字劳动力平台 CloudCC。它是一个成熟的生态系统，拥有超过 1,300 万次安装和 157,000 条用户评审，可帮助您找到适合您独特业务需求的最佳解决方案。现在，借助 AgentExchange，您可以利用最得心应的合作伙伴 Agentforce 解决方案来速捷地建 AI 代理。`,
"home.view.all":`查看全部`,
"message.no.data":`查无数据`,
"message.load.failed":`加载数据失败`,
"message.no.more.data":`没有更多数据了`,
"applist.sponsored.solutions":`推荐行业方案`,
"applist.today.trends":`最新行业方案`,
"applist.view.more":`查看更多`,
"industry.education":`教育行业`,
"industry.manufacturing":`制造行业`,
"industry.it":`IT行业`,
"industry.finance":`金融行业`,
"industry.medical":`医疗行业`,
"resource.data.sheet":`数据表`,
"resource.customer.review":`客户评价`,
"resource.case.study":`案例研究`,
"resource.whitepaper":`白皮书`,
"resource.webinar":`网络研讨会`,
"resource.custom.guide":`定制指南`,
"resource.solutions.sales.cloud":`销售云`,
"resource.solutions.marketing.cloud":`市场云`,
"resource.solutions.service.cloud":`服务云`,
"resource.solutions.office.cloud":`办公云`,
"resource.solutions.hr":`人力资源`,
"resource.solutions.project.management":`项目管理`,
"resource.solutions.other":`其他`,
"resource.category.custom.component":`自定义组件`,
"resource.category.custom.class":`自定义类`,
"resource.category.scheduled.class":`定时类`,
"resource.category.trigger":`触发器`,
"resource.category.client.script":`客户端脚本`,
"resource.industry.automotive":`汽车`,
"resource.industry.consumer.goods":`消费品`,
"resource.industry.communication":`通信`,
"resource.industry.high.end.manufacturing":`高端制造`,
"resource.industry.semiconductor":`半导体芯片`,
"resource.industry.mechanical.equipment":`机械设备`,
"resource.industry.heavy.manufacturing":`重工制造`,
"resource.industry.ai.computing":`AI、算力`,
"resource.industry.internet":`互联网`,
"resource.industry.financial.investment":`金融投资`,
"resource.industry.financing.guarantee":`融资担保`,
"resource.industry.financial.leasing":`融资租赁`,
"resource.industry.insurance":`保险`,
"resource.industry.wealth.management":`财富管理`,
"resource.industry.medical.devices":`医疗器械/IVD`,
"resource.industry.pharmaceutical":`医药`,
"resource.industry.health.elderly.care":`健康养老`,
"resource.industry.medical.service.solution":`医疗服务`,
"resource.industry.education.training":`教育培训`,
"resource.industry.k12":`K12`,
"resource.industry.energy.chemical":`能源化工`,
"resource.industry.nonferrous.metals":`有色金属`,
"resource.industry.steel":`钢铁`,
"resource.industry.park.real.estate":`园区地产`,
"resource.industry.lawyer":`律师`,
"resource.industry.enterprise.service":`企业服务`,
"resource.industry.media.tourism":`媒体旅游`,
"resource.industry.other":`其他`,
"appdetail.price.per.month":`/人/月`,
"appdetail.apply.trial.portal":`体验客户门户`,
"appdetail.apply.trial":`体验CRM`,
"appdetail.apply.demo":`申请演示`,
"appdetail.buy.install":`购买安装`,
"appdetail.app.info":`应用基本信息`,
"appdetail.feature.intro":`功能介绍`,
"appdetail.highlights":`亮点`,
"appdetail.rating":`评分`,
"appdetail.listing.time":`上架时间`,
"appdetail.latest.release":`最新发布`,
"appdetail.supported.terminals":`支持终端`,
"appdetail.version":`版 本 号`,
"appdetail.app.type":`应用类型`,
"appdetail.compatibility":`兼容性`,
"appdetail.app.details":`应用程序详细信息`,
"appdetail.more.details":`更多详情`,
"appdetail.more.from.provider":`更多来自提供商的产品`,
"appdetail.provider.details":`提供商详细信息`,
"appdetail.pricing.details":`定价详情`,
"appdetail.payment.required":`您必须付费才能使用此解决方案。`,
"appdetail.basic.version":`基础版`,
"appdetail.minimum.price":`最低起拍价`,
"appdetail.provided.by":`由{0}提供`,
"appdetail.cloudcc.industry.solution":`CloudCC行业方案`,
"message.no.matches.found":`未找到任何匹配项，请尝试不同的搜索词。`,
"header.access.partner.crm":`18年深耕，凝聚几百家生态伙伴经验，打造30个细分行业的专属CRM`,
"header.industry.demo": `无需注册！立刻进入30个细分行业CRM的DEMO系统，100%真实体验AI和大数据对行业Know How的呈现！`,
"header.login.your.crm":`登录您的CRM系统`,
"appdetail.industry":`所属行业`,
"appdetail.developer":`开 发 者`,
"appdetail.official.website":`官方地址`,
"appdetail.contact.email":`联系邮箱`,
"appdetail.contact.phone":`联系电话`,
"appdetail.confirm.purchase":`是否确认购买`,
"appdetail.tip":`提示`,
"appdetail.confirm":`确定`,
"appdetail.cancel":`取消`,
"appdetail.purchase.success":`购买成功`,
"appdetail.already.purchased":`您已购买此商品`,
"appdetail.limited.time.free":`限 时 免 费`,
"appdetail.ai.building.solution":`AI正在为您构建方案`,
"appdetail.build.failed":`构建失败`,
"appdetail.ai.building.env":`AI正在为您构建试用环境，完成后将自动进入环境，同时您的邮箱将收到登录信息。`,
"appdetail.ai.building.estimate":`预计：2到10分钟完成`,
"appdetail.build.problem":`构建过程中遇到问题，请重试或联系客服`,
"appdetail.building":`构建中...`,
"appdetail.rebuild":`重新构建`,
"appdetail.trial.email.title":`申请试用`,
"appdetail.trial.email.content":`请输入您的邮箱地址，将使用这个邮箱开户试用。同时邮箱会收到登录信息`,
"appdetail.trial.email.placeholder":`请输入邮箱地址`,
"appdetail.trial.email.validation.required":`请输入邮箱地址`,
"appdetail.trial.email.validation.format":`请输入正确的邮箱格式`,
"appdetail.trial.email.validation.exists":`该邮箱已存在，请使用其他邮箱`,
"appdetail.trial.email.exists":`该邮箱已存在，请使用其他邮箱`,
"appdetail.trial.email.check.failed":`邮箱检查失败，请重试`,
"appdetail.trial.email.success":`邮箱验证成功，试用信息已发送`,
"appdetail.trial.email.error":`邮箱验证失败，请重试`,
"label.appstore.priceNumber.jian":`单价*数量*(剩余时长-优惠月)=金额`,
"label.appstore.payTime":`付款时间`,
"label.appstore.industry":`行业`,
"label.appstore.Premium.offer":`按年度订购，可以获取您的超值优惠，一次购买5年时长,优惠20个月费用。`,
"label.appstore.nopay":`未支付`,
"label.appstore.readMore":`阅读更多`,
"label.appstore.prease.enter.emailAddress":`请输入邮件地址`,
"label.appstore.Compare.details":`比较订购计划的明细`,
"label.appstore.Version.upgrade":`版本升级`,
"label.appstore.Request.form":`请求表单`,
"label.appstore.ordeDetail":`订购明细`,
"label.appstore.enter.correct.email":`请输入正确的邮箱地址`,
"label.appstore.function":`功能`,
"label.appstore.accountType":`账号类型`,
"label.appstore.Ordering.plan":`订购计划`,
"label.appstore.cardCode":`信用卡代码`,
"label.appstore.Not.yet.purchased":`您还没有进行任何购买`,
"label.appstore.Order.now":`立即订购`,
"label.appstore.Paymen.method":`支付方式`,
"label.appstore.T&C":`条款与条件`,
"label.appstore.Subtotal":`小计`,
"label.appstore.One.year.discount":`满一年优惠`,
"label.appstore.TotalQuantity":`总数量`,
"label.appstore.PaidAmount":`实付金额`,
"label.appstore.Received":`我们已收到您的请求，会尽快与您联系。`,
"label.appstore.Amount.proportion":`金额使按比例金额所得`,
"label.appstore.enterEms":`请输入邮政编码`,
"label.appstore.terms":`付款条款`,
"label.appstore.change":`更改`,
"label.appstore.place.order":`提交订单`,
"label.appstore.Ordinary.account":`普通账号`,
"label.appstore.UntilMaturity":`距到期日期{0}个月的金额`,
"label.appstore.changeBilling":`将我的账单地址作为我的信用卡地址`,
"label.appstore.newly.added":`新增`,
"label.appstore.buyDuration":`购买时长`,
"label.appstore.change.payoptions":`选择新的付款选项`,
"label.appstore.redirect":`您将被重定向到可以登录的付款网站或者创建一个PayPal账户并更新您的付款方式。`,
"label.appstore.quickTime":`喔！时间过得真快...`,
"label.appstore.enterSurname":`请输入姓`,
"label.appstore.quantity":`数量`,
"label.Version.change.succeeded":`版本更改成功`,
"label.appstore.please.fill.city":`请填写城市`,
"label.appstore.contact.phone":`+1 (800) 820-6983`,
"label.appstore.payment.method.other":`其他付款方式`,
"label.appstore.buy.year.Discount4":`购买满4年优惠14个月`,
"label.appstore.Add.function":`在您的Lightning中添加服务云的现场服务与客户服务功能`,
"label.appstore.Insufficient.privileges":`特权不足`,
"label.appstore.View.order":`查看订购`,
"label.appstore.FillQuantity":`请填写数量后继续`,
"label.appstore.ordernum":`订单号`,
"label.appstore.Upgradeable":`可升级`,
"label.appstore.Remaining.licenses":`许可证剩余数量`,
"label.appstore.Renewal.succeeded":`续费成功`,
"label.appstore.add.User":`添加用户`,
"label.appstore.SeeMore":`查看更多`,
"label.appstore.payment.gateway":`支付网关`,
"label.appstore.enter.VerificationCode":`请输入卡验证码`,
"label.appstore.renew":`续费`,
"label.appstore.Terms.of.service":`服务条款`,
"label.appstore.Billing.updated":`您的账单地址已更新成功，今后所有与该地址相关的订购发票都将使用新的地址.`,
"label.appstore.selectCity":`请选择城市`,
"label.appstore.buy.year.Discount":`购买满1年优惠2个月`,
"label.appstore.AnnualOrder":`按年订购`,
"label.appstore.change.version":`更改版本`,
"label.appstore.EnjoyAuthority":`（享有销售云功能和被分配者管理权限）`,
"label.appstore.HideFeatures":`隐藏功能和附加组件`,
"label.appstore.please.select.time":`请选择时间`,
"label.appstore.idiot.proof":`安全可靠的`,
"label.appstore.notPayment":`未找到付款方式`,
"label.appstore.Manage.subscriptions":`在一个地方管理您所有订购的<a style="color: #075bd5" href="https://www.cloudcc.com/">产品</a>，您一旦订购了 我们的任何产品，它都会在这里。`,
"label.appstore.buy.year.Discount5":`购买满5年优惠20个月`,
"label.appstore.usd.annu":`/用户/月 （按年付费)`,
"label.appstore.Transaction.rejection":`您的交易已经被拒绝了。请联系您的银行获取进一步的详情。`,
"label.appstore.upgrade":`升级`,
"label.appstore.Go.to.order":`转到订单`,
"label.appstore.Amount .paid.now":`现在要支付的金额`,
"label.appstore.TransferOrder":`转移订单`,
"label.appstore.Remaining.duration":`剩余时长`,
"label.appstore.orderId":`订单ID`,
"label.appstore.AfterAdding":`添加后`,
"label.appstore.update":`更新`,
"label.appstore.corporate.name":`公司名称`,
"label.appstore.Please.renew":`请您在到期前一个月内及时在系统中续费，以免影响您的正常使用。`,
"label.appstore.go":`到`,
"label.appstore.FlagshipEdition":`旗舰版`,
"label.appstore.productName":`产品名称`,
"label.appstore.continue1":`继续`,
"label.appstore.back.crm":`返回到CRM`,
"label.appstore.term.of.validity":`有效期`,
"label.appstore.please.fill.MM":`请输入MM`,
"label.appstore.Cancelled":`已取消`,
"label.appstore.click":`点击`,
"label.appstore.please.fill.country":`请填写国家`,
"label.appstore.Application.recommendation":`官方应用程序推荐`,
"label.appstore.user.month":`{0}/user/月`,
"label.appstore.TransactionIDs":`交易ID`,
"label.appstore.nofindbBlling":`没有发现账单地址`,
"label.appstore.Use.other.methods":`使用其他方式`,
"label.appstore.ViewOrderDetail":`查看订购详情`,
"label.appstore.ApplicationVersion":`应用版本`,
"label.select.country.first":`请先选择国家/地区`,
"label.appstore.Successfully.ordered":`您已成功订购我们的标准版计划。`,
"label.appstore.operation":`操作`,
"label.appstore.licensesTotal":`许可证总数`,
"label.appstore.enterName":`请输入名`,
"label.appstore.time.year":`时间(年)`,
"label.appstore.Receive.discount":`按年度订购，可以获取您的超值优惠`,
"label.appstore.workTime":`8小时工作-周一至周五`,
"label.appstore.Payment.failed":`订购付款失败`,
"label.appstore.please.fill.YY":`请输入YY`,
"label.appstore.Billing.information":`账单信息`,
"label.appstore.UserMonth":`{}/user/月`,
"label.appstore.Wrong.mobile":`手机号码格式不对`,
"label.appstore.enddate":`结束日期`,
"label.appstore.buy.products":`如果您要购买我们的产品，请联系我们`,
"label.appstore.user":`用户`,
"label.appstore.ems":`邮政编码`,
"label.appstore.month":`月份`,
"label.appstore.charge":`收费`,
"label.appstore.sign":`这是计算机生成的发票，不需要签名。`,
"label.appstore.ConfirmOrder":`确认订单`,
"label.appstore.Address.and.others":`地址及其他信息`,
"label.appstore.EnterpriseEdition":`企业版`,
"label.appstore.buy.year.Discount3":`购买满3年优惠9个月`,
"label.appstore.years":`年份`,
"label.appstore.product":`产品`,
"label.appstore.payHistory":`支付历史`,
"label.appstore.addUser":`增加User`,
"label.appstore.city":`城市`,
"label.appstore.Discount.months":`优惠20个月`,
"label.appstore.duration":`时长`,
"label.appstore.OrderDuration":`订购时长`,
"label.appstore.selectState":`请选择省/市`,
"label.appstore.enterEmail":`请输入邮箱`,
"label.appstore.Description.text":`描述文字`,
"label.appstore.startdate":`开始日期`,
"label.appstore.Subscription":`已付款`,
"label.appstore.payment":`付款`,
"label.appstore.enter.phone":`请输入电话`,
"label.appstore.VerificationCode":`卡验证码`,
"label.appstore.updated.success":`更新成功`,
"label.appstore.invoicedate":`发票日期`,
"label.appstore.PurchaseDetails":`购买明细`,
"label.appstore.Pro.rata.amount":`按比例金额`,
"label.appstore.countrys":`国家/地区`,
"label.appstore.Due.date":`到期日期`,
"label.appstore.Four.part.order":`4步订购CloudCC`,
"label.appstore.Order.succeeded":`您已成功订购`,
"label.appstore.enter.company.name":`请输入公司名称`,
"label.appstore.shipto":`送货地址`,
"label.appstore.tabpage.ok":`确定`,
"label.appstore.Select.country":`请选择国家/地区`,
"label.appstore.OrderingCenter":`订购中心`,
"label.appstore.usernumber":`用户数`,
"label.appstore.enterPhone":`请输入电话号码`,
"label.appstore.sales.pricing.issues":`销售和定价问题`,
"label.appstore.Transaction.history":`交易历史记录`,
"label.appstore.download.invoice":`下载发票`,
"label.appstore.please.fill.state":`请填写州/省`,
"label.appstore.addAccount":`添加账户`,
"label.appstore.user.number.price":`用户数量*单价`,
"label.appstore.name":`名`,
"label.appstore.Core.account":`用户数量`,
"label.appstore.retry":`重试`,
"label.appstore.buy.year.Discount2":`购买满2年优惠5个月`,
"label.appstore.Download":`下载`,
"label.appstore.months.a":`个月`,
"label.appstore.DueDate.month":`到期日期(月)`,
"label.appstore.RenewalQuantity":`续费数量`,
"label.appstore.continue":`点击“继续”来继续。您将被重定向到可以登录的付款网站或者创建一个PayPal账户并更新您的付款方式。`,
"label.appstore.Environment.version":`环境版本`,
"label.appstore.total":`总额`,
"label.appstore.Early.renewal":`您的订购周期为{0}，到期日期为{1}。请您在到期前一个月内及时在系统中续费，以免影响您的正常使用。`,
"label.appstore.please.enter.cvc":`请输入CVC/CVV`,
"label.appstore.security.policy":`安全策略`,
"label.appstore.Change.details":`更改详情`,
"label.appstore.change.payment":`更改付款方式`,
"label.appstore.dueonreceipt":`立即付款`,
"label.appstore.correct.cardNumber":`请输入卡号`,
"label.appstore.Subscriber":`订购人`,
"label.appstore.whole":`全部`,
"label.appstore.statess":`州/省`,
"label.appstore.payment.method":`付款方式`,
"label.appstore.selectYear":`请选择年份`,
"label.appstore.desc":`描述`,
"label.appstore.Discount.severalYears":`满{0}年优惠`,
"label.appstore.please.enter.lastDate":`请输入到期日期`,
"label.select.state.first":`请先选择省/市`,
"label.appstore.SeveralMonths":`{0}个月`,
"label.appstore.Manage.sub":`管理CloudCC CRM订购`,
"label.appstore.Functional.highlights":`功能亮点`,
"label.appstore.switch.pay":`后续所有付款将切换到新的付款方式。`,
"label.appstore.due.date":`到期日期`,
"label.appstore.status":`状态`,
"label.appstore.Update.billing.details":`更新账单详情`,
"label.appstore.TransactionID":`交易ID:{0}`,
"label.appstore.View.help.page":`有关更多信息，请查看“权限不足错误”帮助页面。`,
"label.appstore.New.order":`新订`,
"label.appstore.Privacy.policy":`隐私政策`,
"label.appstore.order.details":`订购详情`,
"label.appstore.enter.last.name":`请输入姓氏`,
"label.isappstore":`到期日期为`,
"label.appstore.Please.enter.your.name":`请输入您的姓名`,
"label.appstore.enter.a.name":`请输入名字`,
"label.appstore.MonthlyFee":`个月费用`,
"label.appstore.Expired":`已过期`,
"label.appstore.Ordering.history":`订购历史`,
"label.appstore.Payment.transaction.No":`支付交易号`,
"label.appstore.error":`出错了`,
"label.appstore.version":`版本`,
"label.appstore.store.details":`您的商店的详细信息`,
"label.appstore.Payment.method.updated":`您的支付方式已更新成功,今后所有新的订购将使用新的支付方式.`,
"label.appstore.addressDetail":`详细地址`,
"label.appstore.Add.account":`增加账号`,
"label.appstore.Authorization.required":`您需要授权来访问此页面`,
"label.appstore.creditCard":`信用卡`,
"label.appstore.amountPaid":`已付金额`,
"label.appstore.taxinvoice":`支付凭证`,
"label.appstore.createTime":`创建时间`,
"label.appstore.Product.transactionID":`产品/交易ID`,
"label.appstore.Renewal.duration":`续费时长`,
"label.appstore.Amount.month":`金额/月`,
"label.appstore.pay.differen":`或者要继续付款，您可以用不同的信用卡或PayPal账户支付。`,
"label.appstore.Monthly.user":`{0}/用户/每月`,
"label.appstore.display.address":`一旦您订购了我们任意产品，您的账单地址将被显示在这里。`,
"label.appstore.quantity.unit":`数量-单位`,
"label.appstore.onOrder":`已订购`,
"label.appstore.amount.to.be.paic":`需要支付的总金额`,
"label.appstore.Actual.payment.month":`实际支付月`,
"label.appstore.jine":`金额`,
"label.appstore.Please.enter.your.email.address":`请输入您的邮箱地址`,
"label.appstore.Number.partners":`伙伴数量`,
"label.appstore.Submit":`提交`,
"label.appstore.Reserved.rights":`保留一切权利`,
"label.appstore.confirm":`确认`,
"label.appstore.SupportTerminal":`支持终端`,
"label.appstore.phone.num":`电话号码`,
"label.appstore.orderinfo":`订单信息`,
"label.appstore.surname":`姓`,
"label.appstore.date":`日期`,
"label.appstore.delete":`删除`,
"label.appstore.type":`类型`,
"label.appstore.state":`省/市`,
"label.appstore.unprice":`单价`,
"label.appstore.cloudcc":`CloudCC Inc 股份有限公司`,
"label.appstore.contact.us":`联系我们`,
"label.appstore.visit":`访问CloudCC`,
"label.appstore.Purchased.products":`已购产品`,
"label.appstore.amounttt":`金额按比例计算所得`,
"label.appstore.please.enter.cardcode":`请输入信用卡代码`,
"label.appstore.SeveralDays":`{0}天`,
"label.appstore.End.trial":`您的30天试用已结束，现在账户数据仍为您保留15天， 订购后可轻松恢复运行。`,
"label.appstore.email":`邮箱`,
"label.appstore.Quantity.used":`许可证已使用数量`,
"label.appstore.card.number":`卡号`,
"label.appstore.phone":`电话`,
"label.appstore.Offline.payment":`线下支付`,
"label.appstore.showFeatures":`显示功能和附加组件`,
"label.appstore.contact.email":`support@cloudcc.com`,
"label.appstore.Thank.choice":`感谢您选择CloudCC`,
"label.appstore.continue.agree":`如果继续，即表明您同意我们的`,
"label.appstore.Discount":`优惠`,
"label.appstore.Welcome.useCloudcc":`欢迎使用CloudCC Store!`,
"label.appstore.Operation.succeeded":`操作成功`,
"label.appstore.No.view.permission":`您没有查看此页面所需的访问权限级别。如果需要访问权限，请联系记录所有人或您的管理员。`,
"label.appmarket.officialaddress":`官方地址`,
"label.appmarket.free":`免费`,
"label.appmarket.human":`人力资源`,
"label.appmarket.mobileterminal":`支持手机终端`,
"label.appstore.password":`密码`,
"label.appstore.Please.enter.reason.extend":`请输入延长试用原因`,
"label.appmarket.allversions":`所有版本`,
"label.appmarket.make":`制造行业`,
"label.appmarket.placeselect":`请选择`,
"label.appmarket.ContactEmail":`联系邮箱`,
"label.appstore.Cancel.trial":`取消试用`,
"label.appmarket.Contact Number":`联系电话`,
"label.appmarket.morepackage":`该开发者提供更多软件包`,
"label.appmarket.comment":`评论`,
"label.appmarket.partner":`合作伙伴部门`,
"label.appmarket.professional":`专业版`,
"label.appmarket.cooperativepartner":`合作伙伴`,
"label.appmarket.other":`其他`,
"label.appstore.Cancellation.reason":`取消的原因`,
"label.appmarket.automobile":`汽车保险`,
"label.appstore.Please.enter.reason.canceling":`请输入取消试用原因`,
"label.appmarket.crm":`全新的CloudCC CRM生态`,
"label.appstore.length":`长度在 7 到 11 个字符`,
"label.appmarket.appstore":`应用商城`,
"label.appstore.AreYouSure.cancel.account":`您确认要取消您的CloudCC账户吗？`,
"label.appmarket.IT":`IT行业`,
"label.appmarket.edu":`教育行业`,
"label.appstore.version.enterprise":`企业版的所有功能 +`,
"label.appstore.Extended.use":`延长使用`,
"label.appmarket.launchtime":`上架时间`,
"label.appmarket.medical":`医疗行业`,
"label.appmarket.pay":`付费`,
"label.appmarket.solution":`解决方案`,
"label.appmarket.eliminate":`清除`,
"label.appmarket.allprices":`所有价格`,
"label.appstore.Extended.trial":`延长试用`,
"label.appmarket.lastrelease":`最新发布的`,
"label.appstore.website.aboutus.officecall":`电话：`,
"label.appmarket.office":`办公云`,
"label.appmarket.setuptime":`成立时间`,
"label.appstore.expired2":`您的试用已过期`,
"label.appstore.extensionSuccess":`恭喜您！我们已经将您的试用期延长了15天，您即将被重定向到主页。`,
"label.appstore.Upgrade.payment":`我们希望您在试用期间已充分体验产品的功能，若要继续使用CloudCC，请升级到付费版本。`,
"label.appmarket.viewall":`查看全部`,
"label.appmarket.market":`市场云`,
"label.appmarket.unlimited":`无限版`,
"label.appmarket.versionno":`版本号`,
"label.appmarket.industry":`所属行业`,
"label.appstore.Cancel.account":`此操作将取消您的CloudCC账户，您现有的CloudCC数据将迁移到CRM应用的免费版本。`,
"label.appmarket.sales":`销售云`,
"label.appmarket.apply":`应用`,
"label.appmarket.packagecontent":`软件包内容`,
"label.appstore.CancelCC":`取消我的CloudCC账户`,
"label.appstore.Please.enter.password":`请输入密码`,
"label.appstore.experience":`您可以在这里告诉我们您使用CloudCC的体验，我们将会为您延长15天的试用期。`,
"label.appstore.version.free":`基础版的所有功能 +`,
"label.appstore.least.one":`请至少购买1个CloudCC 许可做为管理员账户`,
"label.appmarket.allratings":`所有评分`,
"label.appstore.Dont.continue":`不想继续使用CloudCC？`,
"label.appmarket.finance":`金融行业`,
"label.appmarket.applications":`应用`,
"label.appstore.time.expand":`需要更多时间来尝试这些功能吗？`,
"label.appmarket.computerterminal":`支持电脑终端`,
"label.appmarket.obtain":`立即获取`,
"label.appmarket.components":`组件`,
"label.appstore.actualDuration":`优惠后月数`,
"label.appmarket.score":`评分`,
"label.appmarket.service":`服务云`,
"label.appmarket.for":`适用于`,
"label.appmarket.project":`项目管理`,
"label.appstore.Storetitle":`CloudCC Store`,
"label.appmarket.summary":`概述`,
"label.appstore.version.professional":`专业版的所有功能 +`,
"label.appstore.three.part.order":`3步订购CloudCC`,
"resource.industry.logistics": `物流行业`,
"resource.error.get.user.info": `获取用户信息失败`,
"resource.warning.get.user.info.tips": `请先完善个人基本信息`,
"resource.app.store.title": `个人中心`,
"resource.success": `成功`,
"resource.success.demo.apply": `您已申请成功，稍后伙伴人员会联系您进行演示。`,
"label.account.reg.fail.msg":`注册失败，请稍后重试。`,
"resource.industry.ecommerce":`电子商务`,
"resource.industry.system.integration":`系统集成`,
"resource.industry.paper.products":`造纸和纸制品行业`,

// Personal页面相关
"personal.tab.basic.info": "基本信息",
"personal.tab.account.info": "账号信息",
"personal.tab.my.company": "我的企业",
  "personal.edit": "编辑",
  "personal.new.company": "新建企业",
  "personal.current.company": "当前企业",

// 基本信息字段
"personal.field.avatar": "头像",
"personal.field.name": "姓名",
"personal.field.qq": "QQ号码",
"personal.field.wechat": "微信",
"personal.field.phone": "联系方式",
"personal.field.region": "所在地区",
"personal.field.company.size": "公司规模",
"personal.field.industry": "所属行业",
"personal.field.title": "职位",
"personal.field.num.of.users": "使用人数",
"personal.field.launch.date": "希望上线日期",
"personal.field.pain.point": "需求痛点",
"personal.field.budget": "预算",
"personal.field.language": "语言",

// 账号信息字段
"personal.field.login.account": "登录账号",
"personal.field.password": "密码",
"personal.field.mobile": "手机号",
"personal.field.email": "邮箱",

// 公司规模选项
"personal.company.size.less.than.20": "少于20名员工",
"personal.company.size.21.100": "21-100名员工",
"personal.company.size.101.500": "101-500名员工",
"personal.company.size.501.1000": "501-1000名员工",
"personal.company.size.more.than.1000": "超过1000名员工",

// 职位选项
"personal.title.sales.manager": "销售经理",
"personal.title.marketing.hr.manager": "市场/人事经理",
"personal.title.customer.service.manager": "客服经理",
"personal.title.general.manager": "总经理",
"personal.title.it.manager": "IT经理",
"personal.title.operations.manager": "运营经理",
"personal.title.other": "其他",

// EditBasicInfo页面相关
"personal.edit.basic.info": "完善基本信息",
"personal.cancel": "取消",
"personal.save": "保存",

// Placeholder文本
"personal.placeholder.name": "请输入姓名",
"personal.placeholder.qq": "请输入QQ号码",
"personal.placeholder.wechat": "请输入微信",
"personal.placeholder.phone": "请输入联系方式",
"personal.placeholder.region": "请选择省/市/县",
"personal.placeholder.company.size": "请选择公司规模",
"personal.placeholder.industry": "请输入行业",
"personal.placeholder.title": "请选择职位",
"personal.placeholder.num.of.users": "请输入CRM预计使用人数",
"personal.placeholder.launch.date": "请选择上线日期",
"personal.placeholder.pain.point": "请输入需求痛点（选填）",
"personal.placeholder.budget": "请输入预算（选填）",

// 验证消息
"personal.validation.avatar.required": "请上传头像",
"personal.validation.name.required": "请输入姓名",
"personal.validation.phone.required": "请输入联系方式",
"personal.validation.region.required": "请选择所在地区",
"personal.validation.company.size.required": "请选择公司规模",
"personal.validation.industry.required": "请输入所属行业",
"personal.validation.title.required": "请选择职位",
"personal.validation.num.of.users.required": "请输入使用人数",
"personal.validation.launch.date.required": "请选择希望上线日期",

// 消息提示
"personal.message.save.success": "基本信息保存成功",
"personal.message.save.failed": "保存失败，请重试",
"personal.message.complete.required": "请完善必填信息",

// 头像相关
"personal.avatar.title": "个人头像",
"personal.avatar.description": "上传您的个人头像，支持JPG、PNG、GIF格式，文件大小不超过5MB",
"personal.avatar.upload": "上传头像",
"personal.avatar.uploading": "上传中...",
"personal.avatar.remove": "删除头像",
"personal.avatar.remove.title": "确认删除",
"personal.avatar.remove.confirm": "确定要删除当前头像吗？",
"personal.avatar.remove.success": "头像删除成功",
"personal.avatar.upload.success": "头像上传成功",
"personal.avatar.upload.failed": "头像上传失败",
"personal.avatar.error.invalid.type": "请选择JPG、PNG或GIF格式的图片",
"personal.avatar.error.too.large": "图片大小不能超过5MB",
"personal.avatar.tips": "支持JPG、PNG、GIF格式，文件大小不超过5MB",
"personal.confirm": "确认",

// modifyContact.vue 相关词条
"personal.modify.mobile.title": "修改手机号",
"personal.modify.email.title": "修改邮箱",
"personal.placeholder.mobile": "请输入手机号",
"personal.placeholder.email": "请输入邮箱",
"personal.validation.mobile.required": "请输入手机号",
"personal.validation.email.required": "请输入邮箱",
"personal.validation.mobile.format": "请输入正确的手机号",
"personal.validation.email.format": "请输入正确的邮箱",
"personal.message.mobile.save.success": "手机号修改成功",
"personal.message.email.save.success": "邮箱修改成功",
"personal.message.mobile.duplicate": "手机号已被使用，请更换其他手机号",
"personal.message.complete.info": "请完善信息",

// modifyPassword.vue 相关词条
"personal.modify.password.title": "修改密码",
"personal.field.old.password": "旧密码",
"personal.field.new.password": "新密码",
"personal.field.confirm.password": "确认密码",
"personal.placeholder.old.password": "请输入旧密码",
"personal.placeholder.new.password": "请输入新密码",
"personal.placeholder.confirm.password": "请再次输入新密码",
"personal.validation.old.password.required": "请输入旧密码",
"personal.validation.new.password.required": "请输入新密码",
"personal.validation.new.password.min": "新密码不能少于6位",
"personal.validation.confirm.password.required": "请再次输入新密码",
"personal.validation.confirm.password.mismatch": "两次输入的密码不一致",
"personal.message.password.modify.failed": "修改密码失败，请重试",
"allApps.add.filter":`添加过滤器`,
"allApps.show.results.filter":`显示{0}条结果，筛选条件`,
"allApps.search.filter.placeholder":`搜索过滤器...`,
"applist.all.results":`所有结果`,
// 路由标题
"route.title.home":`首页`,
"route.title.industry.mall":`行业商城`,
"route.title.app.detail":`应用详情`,
"route.title.my.apps":`我的应用`,
"route.title.my.apps.detail":`我的应用详情`,
"route.title.partnership":`合作伙伴`,
"route.title.invoice.management":`发票管理`,
"route.title.create.invoice":`开具发票`,
"route.title.invoice.detail":`发票详情`,
"route.title.personal.center":`个人中心`,
"route.title.app.list":`应用列表`,
"route.title.page.not.found":`页面未找到`,
// Trial 页面
"trial.page.title": "开始试用",
"trial.step1": "步骤一",
"trial.step2": "步骤二",
"trial.step1.title": "您将试用以下功能",
"trial.features.experience": "在你的测试环境中体验",
"trial.features.full.solution": "完整的商业方案",
"trial.features.powerful.paas": "强大的PaaS平台功能",
"trial.features.build.app": "制作您自己的应用",
"trial.features.experience.crm": "体验CRM系统",
"trial.features.experience.portal": "体验客户门户",
"customer.portal.crm.integration": "客户门户与CRM数据打通",
"industry.portal.mall": "符合行业的客户门户或商城",
"fully.integrated.crm": "与CRM完全打通",
"customizable.details": "可根据细节再定制",
"trial.cta.experience.now": "立即体验",
"trial.step2.title": "分享您的联系方式",
"trial.step2.helper": "请输入联系方式，完成留资后，AI将给您开通试用环境，为确保环境持续可用，请您于3日内收取邮件，并修改初始密码，否则AI将自动回收该环境。",
"trial.form.first.name": "名字",
"trial.form.last.name": "姓氏",
"trial.form.email": "电子邮箱",
"trial.form.email.placeholder": "必填，用于接收账号、密码",
"trial.form.company": "公司",
"trial.form.title": "职务",
"trial.form.staff": "员工",
"trial.form.phone": "手机",
"trial.form.country.region": "国家/地区",
"trial.form.agree.privacy": "提交表单信息，表示您已同意并阅读CloudCC隐私协议",
"trial.form.agree.prefix": "提交表单信息，表示您已同意并阅读",
"label.account.pleaseAgree": "请同意并接受服务条款和隐私策略",
"trial.contact.website": "网址",
"trial.contact.email": "电子邮件",
"trial.contact.phone": "电话",
"trial.cta": "我要试用",
"email.check.verification.code": "进入邮箱查看验证码",
"email.send.verification.code": "发送验证码",
"email.fill.verification.code": "请填写邮箱验证码",
"email.verification.sent": "验证码已发送，请前往邮箱查收",
"email.resend.after.seconds": "重新发送({0}s)",
"email.verification.send.failed": "验证码发送失败，请重试",
"trial.disclaimer": "CloudCC不是此方案的提供商，但已进行有限的安全审查。",
"label.account.please.enter.name": "请输入姓名",
"label.account.username.enter": "请输入名字",
"label.account.enter.Emailbox": "请输入邮箱",
"label.account.batchadd.newbatchpage.save.em": "邮箱格式不正确",
"label.account.Company.name": "请输入公司名称",
"label.account.fillMobile": "请输入电话号",
"label.account.only.Numbers": "手机号只能输入数字",
"label.account.phone.length": "手机号长度不能少于7位",
"label.account.reg.phone.already": "该手机在此公司下已经注册",
"label.account.Select.job": "请选择职务",
"label.account.Select.staff": "请选择员工",
"label.account.Select.country": "请选择国家/地区",
"personal.placeholder.language": "请选择语言",
}